export default {
  productList: {
    total: "共 {total} 條",
    filter: "篩選條件",
    sortNum: "暢銷",
    sortPrice: "價格",
    sortEvaluate: "評價",
    sortNew: "新上架",
    filterCategory: "分類",
    filterBrand: "品牌",
    filterTemperature: "保存方式",
    filterOrigin: "產地",
    couponDetail: '優惠券詳情',
    searchTitle: "{search}的搜索結果",
    proTitle: "商品列表",
    noProduct: "沒有找到您想要的商品哦！",
    allClear: '全部清除'
  },
  productDetail: {
    productDetail: '商品詳情',
    productStocknumTag: "在庫緊張",
    proRateNum: "{num} 條評論",
    countdownNum: "限{num}份",
    countdownTime: "距活動結束還有",
    countStarTime: "距活動開始還有",
    proBrand: "品牌",
    proCode: "編號",
    proTemperature: "運輸方式",
    proOrigin: "原產地",
    proPoints: "贈送積分",
    proCoupon: "優惠券",
    proCouponMore: "更多優惠券",
    proPromotion: "促銷",
    proPromotionMore: "查看詳情",
    delivery: "配送至",
    deliveryTime: "最快送達日 {date}",
    proNum: "數量",
    proNoNum: "對不起, 該商品暫無庫存!",
    btnAddCart: "加入購物車",
    arrivalNotice: "到貨通知",
    arrivalNoticeProp: "已添加到貨通知",
    btnProOff: "商品已下架",
    proCollection: "收藏",
    proDescTitle: "商品描述",
    proDescParam: "規格詳細",
    proReviews: "商品評價",
    proSaleTitle: "促銷商品",
    proLatelyTitle: "最近看過的商品",
    proCouponTitle: "領取優惠券",
    proCouponBtnAdd: "立即領取",
    proCouponBtn: "已領取",
    proCouponBtnGo: "立即使用",
    disposals: "處分品",
    relatedgoods: "相關商品",
    couponLable: '可領取',
    couponLable1: '已領取',
    couponType1: '滿減券',
    couponType2: '滿折券',
    couponType3: '運費抵用券',
    couponType1UseMoney_text1: '滿{useMoneyCondition}減{discountInfo}',
    couponType1NoUseMoney: '不限金額減{discountInfo}',
    couponType2UseMoney: '滿{useMoneyCondition}享{discountInfo}%OFF',
    couponType2NoUseMoney: '不限金額享{discountInfo}%OFF',
    couponType3UseMoney: '滿{useMoneyCondition}免運費{discountInfo}',
    couponType3NoUseMoney: '不限金額免運費{discountInfo}',
    freeTransportName: '免運費{freetransportName}',
    couponProductType: '指定商品可使用',
    couponProductType0: '全部商品可用',
    couponProductType1: '指定商品可使用',
    couponProductType2: '指定商品可使用',
    freeTransportType: '{freeTransportAreaName}免運費',
    freeTransportTypeYw: '{freeTransportAreaName}以外免運費',
    receiveNum: '限領{num}張',
    useDate: '有效期',
    dateInterval: '至',
    dateSameDay: '領券當日開始 {day} 天有效',
    dateNextDay: '領券次日開始 {day} 天有效',
    receive: '領取',
    toUse: '去使用',
    CouponSuccess: '領取成功',
    CollectSuccess: '收藏成功',
    CollectDeleteSuccess: '取消成功',
    fastReceiveDateTootip: '系統會根據您的配送地址預估最快送達日。您還可以在結賬頁面免費指定收貨時間。*如遇天候，交通狀況等不可抗力因素，配達可能會延遲，還望理解。',
    noComments: '暫無評價',
    activitTextStart: '距活動開始還有',
    activitTextEnd: '距活動結束還有',
    day: '天',
    hour: '小時',
    minute: '分鐘',
    second: '秒',
    all: '全部',
    picture: '有圖',
    praise: '讚',
    middle_feedback: '普通',
    negative_feedback: '不喜歡',
    current: '只瀏覽選擇商品的評價',
    noEvaluate: '暫無評論',
    nodesc: '暫無商品資訊哦~~'
  }
};